import React, { useState } from "react";
import BlackLogo from "../assets/ecositeAsset.png";
import CustomModal from "./CustomModal";
import { FaTwitter, FaLinkedin } from "react-icons/fa";
import SiteImage from "../assets/banner_2.webp";

const SiteHomePage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  // House data
  const houseData = {
    lat: 51.3721214,
    lng: -0.45766150000000116,
    aoi_name: "Bournemouth, UK",
    roof_material: "metal",
    yearly_energy_dc_kwh: 3854.121,
    max_yearly_energy_dc_kwh: 3854.121,
    installation_size_kw_available_area: 4.75,
    installation_cost_available_area: 4037.5,
    roof_area: 57.82903,
    panels_count: 19,
    installation_cost: 4037.5,
  };

  return (
    <div className="flex flex-col min-h-screen bg-green-50">
      <header className="bg-[#2d9376] shadow-sm fixed top-0 left-0 right-0 z-50">
        <div className="container mx-auto px-4 py-4 flex justify-between items-center">
          <img src={BlackLogo} alt="Logo" className="h-8 w-26" />
          <nav>
            <ul className="flex space-x-6">
              <li>
                <a
                  href="/"
                  className="text-black hover:bg-[#2d9376] transition duration-300"
                >
                  Home
                </a>
              </li>
              <li>
                <a
                  href="/about"
                  className="text-black hover:text-green-400 transition duration-300"
                >
                  About
                </a>
              </li>
              <li>
                <a
                  href="/login"
                  className="text-black hover:text-green-400 transition duration-300"
                >
                  Portal
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-black hover:text-green-400 font-bold transition duration-300"
                  onClick={openModal}
                >
                  Contact Us
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </header>
      <CustomModal isOpen={isModalOpen} onRequestClose={closeModal} />
      <main className="flex-grow relative pt-24 pb-16">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold text-center mb-12 text-green-800">
            Look what we have realized about your site!
          </h1>

          <div className="bg-white rounded-lg shadow-lg overflow-hidden">
            <div className="md:flex">
              <div className="md:w-1/2">
                <img
                  src={SiteImage}
                  alt="House"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="md:w-1/2 p-6">
                <h2 className="text-2xl font-semibold mb-4 text-green-700">
                  {houseData.aoi_name}
                </h2>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <p className="font-medium text-gray-600">Roof Material</p>
                    <p className="text-lg">{houseData.roof_material}</p>
                  </div>
                  <div>
                    <p className="font-medium text-gray-600">Roof Area</p>
                    <p className="text-lg">
                      {houseData.roof_area.toFixed(2)} m²
                    </p>
                  </div>
                  <div>
                    <p className="font-medium text-gray-600">
                      Yearly Energy (DC)
                    </p>
                    <p className="text-lg">
                      {houseData.yearly_energy_dc_kwh.toFixed(2)} kWh
                    </p>
                  </div>
                  <div>
                    <p className="font-medium text-gray-600">
                      Installation Size
                    </p>
                    <p className="text-lg">
                      {houseData.installation_size_kw_available_area.toFixed(2)}{" "}
                      kW
                    </p>
                  </div>
                  <div>
                    <p className="font-medium text-gray-600">Panels Count</p>
                    <p className="text-lg">{houseData.panels_count}</p>
                  </div>
                  <div>
                    <p className="font-medium text-gray-600">
                      Installation Cost
                    </p>
                    <p className="text-lg">
                      £{houseData.installation_cost.toFixed(2)}
                    </p>
                  </div>
                  <div>
                    <p className="font-medium text-gray-600">
                      Max Yearly Energy (DC)
                    </p>
                    <p className="text-lg">
                      {houseData.max_yearly_energy_dc_kwh.toFixed(2)} kWh
                    </p>
                  </div>
                  <div>
                    <p className="font-medium text-gray-600">
                      Installation area
                    </p>
                    <p className="text-lg">
                      {houseData.installation_size_kw_available_area.toFixed(2)}{" "}
                      m²
                    </p>
                  </div>
                </div>
                <div className="mt-6">
                  <h3 className="text-xl font-semibold mb-2 text-green-700">
                    Location
                  </h3>
                  <p>Latitude: {houseData.lat}</p>
                  <p>Longitude: {houseData.lng}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      {/* Footer */}
      <footer className="bg-gray-800 text-white py-8">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-lg font-semibold mb-4">About</h3>
              <ul className="space-y-2">
                <li>
                  <a href="/about" className="hover:text-green-400">
                    Our Story
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">Follow Us</h3>
              <div className="flex space-x-4">
                {/* <a
                  href="https://x.com/ecositeltd"
                  target="_blank"
                  className="text-xl hover:text-green-400"
                >
                  <FaTwitter />
                </a> */}
                <a
                  href="https://www.linkedin.com/company/ecosite-ltd/"
                  target="_blank"
                  className="text-xl hover:text-green-400"
                >
                  <FaLinkedin />
                </a>
              </div>
            </div>
          </div>
          <div className="mt-8 pt-8 border-t border-gray-700 text-center">
            <p>&copy; 2024 Ecosite. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default SiteHomePage;
